// mixin.js
export default {
    methods:{
        getStaticImage(image){
            return window.cordova ? ("file:./img/" + image) : require("@/assets/img/" + image);
        }
    }
};
